module.exports = __webpack_public_path__ + "static/media/icon／icon_jiaoyixiangqing_shibai.919bdaa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon／icon_jiaoyixiangqing_shibai.png
// module id = 1777
// module chunks = 0 1